<template>
    <div v-if="taskContent">
        <div v-if="myContent.task_type_id >=2 && myContent.task_type_id <=4">
            <div v-html="taskContent.content"></div>
            <br> 
            <v-card outlined>
                <v-card-text>
                Answers:    
                    <ul>
                        <li v-for="(task,index) in taskOptions" :key="index">
                            <span v-if="task.rating > 0"><b>{{ task.answer}}</b></span>
                            <span v-if="task.rating <= 0">{{ task.answer}}</span>
                        </li>
                    </ul>
                </v-card-text>
            </v-card>
        </div>
        
        <div v-if="myContent.task_type_id ==5 || myContent.task_type_id ==6" v-html="taskContent" ></div>
        <div v-if="myContent.task_type_id ==7">
            <div v-html="taskContent"></div>
            <br> 
            <v-card outlined>
                <v-card-text>
                    Answers:
                    <div v-for="(line, index) in lines" :key="index" v-html="line">
                    </div>
                </v-card-text>
            </v-card>
        </div> 
        <div v-if="myContent.task_type_id >=8 || myContent.task_type_id <=11">
            <h3>{{taskContent.title}}</h3>
            <div v-html="taskContent.assignment" ></div>
        </div>
      
    </div>
</template>

<script>
export default {
    data() {
        return {
            taskContent: null,
            taskOptions: [],
            lines: []
        }
    },
    props: {
        myContent: Object
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            if (this.myContent.task_type_id >= 2 && this.myContent.task_type_id <= 4) this.prepare234()
            if (this.myContent.task_type_id == 5 || this.myContent.task_type_id == 6) this.prepare56()
            if (this.myContent.task_type_id == 7) this.prepare7()
            if (this.myContent.task_type_id >= 8 && this.myContent.task_type_id <= 11)  this.prepare811()
        },
        prepare234(){
            const _data = JSON.parse(this.myContent.content);
            const _globals = JSON.parse(this.myContent.globals);
            this.taskOptions = []
            for(let i = 0; i < _data.answer_list.length; i++) {
                this.taskOptions.push({
                    answer: _data.answer_list[i].answer,
                    rating: _globals.ratings[i]
                })
            }
            this.taskContent = {
                content: _data.content
            }
        },
        prepare56() {
            const _data = JSON.parse(this.myContent.content);
            this.taskContent = this.processTask56(_data.content)
        },
        processTask56(_data) {
            let _arr = ['<span style="background-color:blue">','</span>']
            let index = 0
            while (_data.indexOf('§§')>-1) {
                let i = _data.indexOf('§§')
                _data = _data.substring(0,i) + _arr[index] + _data.substring(i+2)
                index = 1 - index
            }
            return _data
        },
        prepare7() {
            const _data = JSON.parse(this.myContent.content);
            this.taskContent = _data.content
            this.lines = _data.codes
        },
        prepare811() {
            this.taskContent = JSON.parse(this.myContent.content)
        }
    }
}

</script>